import { render, staticRenderFns } from "./AcademyStudentsGeneralLearningProgress.vue?vue&type=template&id=53238d21&scoped=true&lang=pug&"
import script from "./AcademyStudentsGeneralLearningProgress.vue?vue&type=script&lang=ts&"
export * from "./AcademyStudentsGeneralLearningProgress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53238d21",
  null
  
)

export default component.exports